import React, { useState } from "react";
import banner1 from "../assets/img/header-banner.jpg";
import { garllery } from "../constants/garllery";

const Promotion = () => {
  return (
    <div className="bg-gray-50">
      {/* Banner */}
      <div
        className="relative w-full h-[150px] md:h-[180px]
        bg-center bg-cover bg-no-repeat flex justify-center items-center"
        style={{ backgroundImage: `url(${banner1})` }}
      >
        <div className="absolute inset-0 bg-white/60"></div>

        <h1
          data-aos="fade-up"
          className="relative uppercase text-2xl md:text-3xl font-bold text-center text-gray-900 tracking-wide"
        >
          Gallery
          <div className="mt-3 mx-auto w-24 border-b-2 border-yellow-400"></div>
        </h1>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-7 py-6 px-4 sm:px-6 md:px-6 lg:px-6">
        {garllery.map((item, index) => (
          <GalleryCard key={index} image={item.image} />
        ))}
      </div>
    </div>
  );
};

export default Promotion;

/* --------------------------------
   Gallery Card with Placeholder
---------------------------------- */

const GalleryCard = ({ image }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className="group relative rounded-3xl overflow-hidden bg-white
      shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
    >
      <div className="relative aspect-square overflow-hidden">
        {/* Skeleton Placeholder */}
        {!loaded && (
          <div className="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-300 to-gray-200 animate-pulse" />
        )}
        {/* Image */}
        <img
          src={image}
          alt="Food"
          loading="lazy"
          decoding="async"
          onLoad={() => setLoaded(true)}
          className={`w-full h-full object-cover
          transition-all duration-700 ease-out
          ${loaded ? "opacity-100" : "opacity-0"}
          group-hover:scale-110`}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/35 transition-all duration-500" />
      </div>

      {/* Soft glow border */}
      <div className="absolute inset-0 rounded-3xl ring-1 ring-transparent group-hover:ring-yellow-400/40 transition-all duration-500" />

      {/* Premium light sweep */}
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700
        bg-gradient-to-tr from-transparent via-white/15 to-transparent"
      />
    </div>
  );
};
